// extracted by mini-css-extract-plugin
module.exports = {"bg":"terms_bg__BU3bP","content":"terms_content__3DUdI","list":"terms_list__14wJ5","list1":"terms_list1__3u8pe"};